// Convert a captured message into fields used by the Reader Events columns.
const title = input => (input == null ? 'Not reported' : String(input).replace(/^./, letter => letter.toUpperCase()));

export function eventCard(message) {
    let body = message.text;
    try {
        body = JSON.parse(body);
    } catch {
        // Non-JSON messages still need to be readable; exports retain the original text.
    }
    return {
        _id: message.id,
        heading: message.command || title(message.category),
        status: title(message.direction),
        at: message.at,
        description: [
            message.category,
            message.count > 1 && `${message.count} occurrences in one minute`,
            message.truncated && 'Message shortened to 64 KiB',
            message.omittedBefore > 0 && `${message.omittedBefore} messages omitted`
        ]
            .filter(Boolean)
            .join(' · '),
        details: {
            topic: message.topic,
            commandId: message.commandId,
            count: message.count,
            lastAt: message.lastAt,
            payload: body
        }
    };
}

/** Filtering is a count over a window, not a trace of individual tag IDs. */
export function captureCards(data) {
    if (!data) return [];
    const operation = data.operation?.action === 'capture' ? data.operation : null;
    // A new or failed capture must not display counters from an earlier window.
    const filtering = operation
        ? operation.results
              ?.slice()
              .reverse()
              .find(result => result.value?.capture)?.value
        : data.filtering;
    if (!operation && !filtering?.capture) return [];
    const capture = filtering?.capture;
    const counts = capture?.counts;
    const count = name => counts?.[name] ?? 'Not reported';
    const window =
        capture?.startedAt && capture?.endsAt
            ? `${new Date(capture.startedAt).toLocaleTimeString()} – ${new Date(capture.endsAt).toLocaleTimeString()}`
            : '60-second window';
    const active = operation?.status === 'active';
    return [
        {
            _id: 'filtering-capture',
            heading: 'Filtering capture',
            at: capture?.startedAt || operation?.createdAt || data.filteringAt,
            status: active
                ? 'Capture in progress'
                : title(operation?.status || (capture?.complete ? 'complete' : 'last capture')),
            description: [
                window,
                active
                    ? 'Collecting counts. Results appear when the reader replies after the window ends.'
                    : operation?.reason,
                counts && `Received: ${count('received')} · Forwarded: ${count('forwarded')}`,
                counts &&
                    `Suppressed: cooldown ${count('cooldown')} · weak signal ${count('weakSignal')} · missing ID ${count('missingId')} · unmapped port ${count('unmappedPort')}`
            ]
                .filter(Boolean)
                .join('\n'),
            details: { captureWindow: capture || null, lifetimeCounts: filtering?.counts || null, operation }
        }
    ];
}
